import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, PhoneIncoming } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../ui/Button';
interface CallsEmptyStateProps {
  /** True once call forwarding is set up for at least one situation. */
  forwardingConfigured: boolean;
  onSetUpCallAnswering: () => void;
  /** Internal testing only — omit to hide the link from production users. */
  onLoadSampleCalls?: () => void;
}
export function CallsEmptyState({
  forwardingConfigured,
  onSetUpCallAnswering,
  onLoadSampleCalls
}: CallsEmptyStateProps) {
  const {
    isLight
  } = useTheme();
  return <div className="flex min-h-full flex-col px-8 pt-10" data-id="element-390" data-mp="3pujo0rnmxazw">
      <motion.section data-tour="calls-list-item" initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex flex-1 flex-col items-center justify-center pb-10 text-center" data-id="element-391" data-mp="3uv7n80m0oy57">
        <div className="relative mb-7 grid h-24 w-24 place-items-center" data-id="element-392" data-mp="2gkvgcqccjr6s">
          <span aria-hidden className={`absolute inset-0 rounded-full ${isLight ? 'bg-vexu/[0.06]' : 'bg-vexu/[0.08]'}`} data-id="element-393" data-mp="2bls9r1gpxcwp" />
          <span aria-hidden className={`absolute inset-3 rounded-full ${isLight ? 'bg-vexu/10' : 'bg-vexu/[0.12]'}`} data-id="element-394" data-mp="27i40mecfu99c" />
          <PhoneIncoming className={`relative h-8 w-8 ${isLight ? 'text-vexu-700' : 'text-vexu'}`} strokeWidth={1.75} data-id="element-395" data-mp="1xmat59dkt5yf" />
        </div>

        <h2 className={`text-xl font-bold tracking-tight ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-396" data-mp="1su99v3hzqeyw">No calls yet</h2>
        <p className={`mx-auto mt-2.5 max-w-[17rem] text-sm leading-relaxed ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-397" data-mp="1ntv986ipy7aw">
          Once Vexu answers your first call, you'll find its transcript, summary, and recordings right here.
        </p>

        {forwardingConfigured ? <p className={`mt-7 inline-flex items-center gap-1.5 text-[13px] font-medium ${isLight ? 'text-vexu-700' : 'text-vexu'}`} data-id="element-398" data-mp="19wot6jpdqmpd">
            <CheckCircle2 className="h-4 w-4" data-id="element-399" data-mp="1586zc4jyv55o" />
            Your AI assistant is ready for incoming calls.
          </p> : <Button onClick={onSetUpCallAnswering} className="mt-7 px-6 py-3" data-id="element-400" data-mp="qby196btaxuu">
            Set Up Call Answering
          </Button>}
      </motion.section>

      {onLoadSampleCalls && <div className="pb-6 text-center" data-id="element-401" data-mp="1j0dcdhrtow0w">
          <button type="button" onClick={onLoadSampleCalls} className={`text-[11px] font-medium underline-offset-2 hover:underline ${isLight ? 'text-slate-400 hover:text-slate-600' : 'text-zinc-600 hover:text-zinc-400'}`} data-id="element-402" data-mp="1ny5hjdhhaen1">
            Simulate call history
          </button>
        </div>}
    </div>;
}